import { mount } from 'svelte';
import Home from './Home.svelte';
import { ProjectDB } from './idb.js';

const app = document.getElementById('app')!;
ProjectDB.open()
  .then((db) => mount(Home, { target: app, props: { db } }))
  .catch((e: Error) => {
    app.textContent = `This browser can't store projects: ${e.message}`;
  });
